import { useEffect } from 'react';
import mapboxgl, { Map } from 'mapbox-gl';
import { useMapContext } from '../contexts/mapContext';

const MAPBOX_GL_ACCESS_TOKEN =
	'pk.eyJ1IjoibWNkbzYxNSIsImEiOiJjazNwMmE3N28yN2RmM2JwaHBwa2tmcXd4In0.ON4OyuWKVBOHqwlWEiE_jw';

export default function useMap() {
	const [{ mapRef }, { setMap }] = useMapContext();

	useEffect(() => {
		if (!mapRef) return;
		mapboxgl.accessToken = MAPBOX_GL_ACCESS_TOKEN;

		const options = {
			center: {
				lng: -98.5795,
				lat: 39.8283,
			},
			container: mapRef?.current ?? 'unknown',
			style: `mapbox://styles/mapbox/light-v10`,
			logoPosition: 'bottom-left',
			zoom: 3,
			attributionControl: false,
			sources: {},
		};
		const m = new Map(options);
		m.on('load', () => {
			setMap(m);
		});
	}, [setMap, mapRef]);
}
